import { Block } from '@contensis/canvas-html';
import { JSONPath } from 'jsonpath-plus';

/**
 * Uses JSONPath to find all objects with id matching the blockId
 * returning the first found block
 */
export const findBlockById = (blockId: string, canvas: Block[]) => {
  if (!blockId || !Array.isArray(canvas)) return undefined;

  const foundBlocks = JSONPath({
    path: `$..[?(@.id === '${blockId}')]`,
    json: canvas.filter((b) => !!b),
    ignoreEvalErrors: true,
  }) as Block[];

  return foundBlocks.length ? foundBlocks[0] : undefined;
};
